import { Flame, Building2, Factory, Wrench } from "lucide-react";
import oilGas from "@/assets/hero-industrial.jpg";
import construction from "@/assets/industry-construction.jpg";
import plants from "@/assets/industry-plants.jpg";
import maintenance from "@/assets/industry-maintenance.jpg";
import { useLanguage } from "@/contexts/LanguageContext";
import { SectionHeading } from "@/components/ui/section-heading";

const industriesEn = [
  { icon: Flame, title: "Oil & Gas", image: oilGas },
  { icon: Building2, title: "Construction", image: construction },
  { icon: Factory, title: "Industrial Plants", image: plants },
  { icon: Wrench, title: "Maintenance & Shutdown", image: maintenance },
];

const industriesAr = [
  { icon: Flame, title: "النفط والغاز", image: oilGas },
  { icon: Building2, title: "البناء والتشييد", image: construction },
  { icon: Factory, title: "المصانع الصناعية", image: plants },
  { icon: Wrench, title: "الصيانة والإيقاف", image: maintenance },
];

const Industries = () => {
  const { language } = useLanguage();
  const isAr = language === 'ar';
  const industries = isAr ? industriesAr : industriesEn;
  const eyebrow = isAr ? "القطاعات التي نخدمها" : "Sectors we serve";
  const h1 = isAr ? "الصناعات" : "Industries";
  const h2 = isAr ? "التي نخدمها" : "Served";
  return (
    <section id="industries" className="py-20 bg-background">
      <div className="container mx-auto px-6 lg:px-8">
        <SectionHeading
          centered
          eyebrow={eyebrow}
          accent={h2}
          wrapperClassName="mb-14 max-w-2xl"
        >
          {h1}
        </SectionHeading>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {industries.map((i) => (
            <div
              key={i.title}
              className="group relative rounded-xl overflow-hidden aspect-[4/3] shadow-soft hover:shadow-elegant transition-smooth"
            >
              <img
                src={i.image}
                alt={i.title}
                loading="lazy"
                width={1024}
                height={768}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-elegant"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-darker via-primary-darker/60 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4 flex items-center gap-2 text-primary-foreground">
                <i.icon className="w-5 h-5 text-accent flex-shrink-0" />
                <h3 className="font-bold text-base sm:text-lg uppercase tracking-wide">{i.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;